import React, { FC } from 'react';
import { Box } from '../../Box';
import { Text } from '../../Text';

import styled from '../Tab.scss';

interface ITabItemCounterProps {
  count: number;
}

export const TabItemCounter: FC<ITabItemCounterProps> = ({ count }) => {
  return (
    <Box className={styled.counter}>
      <Text id={'tabItemCount'} size={'secondary'}>
        {count}
      </Text>
    </Box>
  );
};
